import React from 'react';
import { AppTile } from '../AppCollectionCarousel/tile';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { App } from '../../models/app';

type ComponentProps = {
  app?: App;
  title?: string | JSX.Element;
  description?: string;
  hideDescription?: boolean;
  role?:string
};

export const PageInfo: React.FC<ComponentProps> = ({
  app,
  title,
  description,
  hideDescription,
  role
}): JSX.Element => {
  const [t] = useTranslation();
  return (
    <>
      {app ? (
        <AppTile app={app} align="left" />
      ) : (
        <div className={styles.pageInfoContainer} >
          <h1 className={styles.title} role={role}>{title || t('clover_app_store.title')}</h1>
          {!hideDescription && <h2 className={styles.description}>
            {description ? description : t('clover_app_store.description')}
          </h2>}
        </div>
      )}
    </>
  );
};
